import { render, staticRenderFns } from "./WanatelPbxWizard.vue?vue&type=template&id=4beaa22a&"
import script from "./WanatelPbxWizard.vue?vue&type=script&lang=js&"
export * from "./WanatelPbxWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports